import React, { Component } from "react";
import { injectIntl } from "react-intl";
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Input
} from "reactstrap";

import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

import {
  setContainerClassnames,
  clickOnMobileMenu,
  loginUser,
  logoutUser,
  changeLocale,
  setCurrentTenant,
  setMenuItems,
  setLoader
} from "../../redux/actions";

import {
  menuHiddenBreakpoint,
  isDarkSwitchActive,
  searchPath,
  topNavOptions,
  tenants
} from "../../config/defaultValues";

import IntlMessages from "../../helpers/IntlMessages";
import { MobileMenuIcon, MenuIcon } from "../../components/svg";
import TopnavEasyAccess from "./Topnav.EasyAccess";
import TopnavNotifications from "./Topnav.Notifications";
import TopnavDarkSwitch from "./Topnav.DarkSwitch";
import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import { getDirection, setDirection } from "../../helpers/Utils";
import ContactModal from "../../components/utils/ContactModal";

class TopNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInFullScreen: false,
      searchKeyword: "",
      modalOpen: false
    };

    if (this.props.currentTenant && this.props.currentTenant.id !== 0) this.getTenant(this.props.currentTenant.id);

  }

  handleChangeLocale = (locale, direction) => {
    this.props.changeLocale(locale);

    const currentDirection = getDirection().direction;
    if (direction !== currentDirection) {
      setDirection(direction);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  handleChangeTenant = (t) => {
    if (t.id === 0) return;
    this.props.setCurrentTenant(t);
    this.props.setLoader(true);
    window.location.reload();
  };

  getTenant = (id) => {
    if (id === undefined) {
      // get from local
      let menu = JSON.parse(localStorage.getItem('menu_items'));
      this.props.setMenuItems(menu, true);
      return;
    }
    _axios.get(tenants.pathOne + '/' + id)
    .then(r => {
      if (r.status >= 0) {
        this.props.setMenuItems(r.data.menu, true)
      }
      NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
    })
  };

  isInFullScreen = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };

  handleSearchIconClick = e => {
    if (window.innerWidth < menuHiddenBreakpoint) {
      let elem = e.target;
      if (!e.target.classList.contains("search")) {
        if (e.target.parentElement.classList.contains("search")) {
          elem = e.target.parentElement;
        } else if (
          e.target.parentElement.parentElement.classList.contains("search")
        ) {
          elem = e.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains("mobile-view")) {
        this.search();
        elem.classList.remove("mobile-view");
        this.removeEventsSearch();
      } else {
        elem.classList.add("mobile-view");
        this.addEventsSearch();
      }
    } else {
      this.search();
    }
  };

  addEventsSearch = () => {
    document.addEventListener("click", this.handleDocumentClickSearch, true);
  };

  removeEventsSearch = () => {
    document.removeEventListener("click", this.handleDocumentClickSearch, true);
  };

  handleDocumentClickSearch = e => {
    let isSearchClick = false;
    if (
      e.target &&
      e.target.classList &&
      (e.target.classList.contains("navbar") ||
        e.target.classList.contains("simple-icon-magnifier"))
    ) {
      isSearchClick = true;
      if (e.target.classList.contains("simple-icon-magnifier")) {
        this.search();
      }
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      e.target.parentElement.classList.contains("search")
    ) {
      isSearchClick = true;
    }

    if (!isSearchClick) {
      const input = document.querySelector(".mobile-view");
      if (input && input.classList) input.classList.remove("mobile-view");
      this.removeEventsSearch();
      this.setState({
        searchKeyword: ""
      });
    }
  };

  handleSearchInputChange = e => {
    this.setState({
      searchKeyword: e.target.value
    });
  };

  handleSearchInputKeyPress = e => {
    if (e.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    this.props.history.push("/app/pages/search/" + this.state.searchKeyword);
    this.setState({
      searchKeyword: ""
    });
  };

  toggleModal = () => {
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  };

  toggleFullScreen = () => {
    const isInFullScreen = this.isInFullScreen();

    var docElm = document.documentElement;
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    this.setState({
      isInFullScreen: !isInFullScreen
    });
  };

  handleLogout = () => {
    this.props.logoutUser(this.props.history);
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    e.preventDefault();

    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };

  mobileMenuButtonClick = (e, containerClassnames) => {
    e.preventDefault();
    this.props.clickOnMobileMenu(containerClassnames);
  };

  render() {
    const { containerClassnames, menuClickCount, locale, currentTenant, userAdmin } = this.props;
    const { messages } = this.props.intl;
    return (
      <nav className="navbar fixed-top">


        <ContactModal
          modalOpen={this.state.modalOpen}
          toggleModal={this.toggleModal}
        />
        <div className="d-flex align-items-center navbar-left">
          <div>
            <NavLink
              to="#"
              className="menu-button d-none d-md-block"
              onClick={e =>
                this.menuButtonClick(e, menuClickCount, containerClassnames)
              }
            >
              <MenuIcon />
            </NavLink>
            <NavLink
              to="#"
              className="menu-button-mobile d-xs-block d-sm-block d-md-none"
              onClick={e => this.mobileMenuButtonClick(e, containerClassnames)}
            >
              <MobileMenuIcon />
            </NavLink>
          </div>

          {searchPath.length > 0 && <div className="search" data-search-path="/app/pages/search">
            <Input
              name="searchKeyword"
              id="searchKeyword"
              placeholder={messages["menu.search"]}
              value={this.state.searchKeyword}
              onChange={e => this.handleSearchInputChange(e)}
              onKeyPress={e => this.handleSearchInputKeyPress(e)}
            />
            <span
              className="search-icon"
              onClick={e => this.handleSearchIconClick(e)}
            >
              <i className="simple-icon-magnifier" />
            </span>
          </div>
          }

          {currentTenant && <div className="d-inline-block">
            {this.props.tenants.length > 1 &&
              <UncontrolledDropdown className="ml-2">
                <DropdownToggle
                  caret
                  color="light"
                  size="sm"
                  className="language-button"
                >
                  <span className="name">{currentTenant.name}</span>
                </DropdownToggle>
                <DropdownMenu className="mt-3" right modifiers={{
                  setMaxHeight: {
                    enabled: true,
                    fn: (data) => {
                      return {
                        ...data,
                        styles: {
                          ...data.styles,
                          overflow: 'auto',
                          maxHeight: window.innerHeight - 100,
                        },
                      };
                    },
                  }
                }}>
                  {this.props.tenants.map(l => {
                    return (
                      <DropdownItem
                        onClick={() => this.handleChangeTenant(l)}
                        key={l.id}
                      >
                        {l.name}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            }
            {this.props.tenants.length === 1 &&
              <div className="ml-2"><strong>{currentTenant.name} {window.tenant.version || ''}</strong></div>
            }
          </div>}

          {window.tenant.localeOptions && window.tenant.localeOptions.length > 1 && <div className={currentTenant ? 'd-none d-sm-inline-block' : 'd-inline-block'}>
            <UncontrolledDropdown className="ml-2">
              <DropdownToggle
                caret
                color="light"
                size="sm"
                className="language-button"
              >
                <span className="name">{locale.toUpperCase()}</span>
              </DropdownToggle>
              <DropdownMenu className="mt-3" right>
                {window.tenant.localeOptions.map(l => {
                  return (
                    <DropdownItem
                      onClick={() => this.handleChangeLocale(l.id, l.direction)}
                      key={l.id}
                    >
                      <IntlMessages id={l.name} />
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>}
        </div>
        <a className="navbar-logo" href="#/app/home/start">
          {
          /*
          <span className="logo d-none d-xs-block" />
          <span className="logo-mobile d-block d-xs-none" />
          */
          }
          <img alt="Profile" src={window.tenant.logo} onError={(e) => { e.target.onerror = null; e.target.src = require("../../assets/img/user.png") }} />
        </a>
        <div className="navbar-right">
          {isDarkSwitchActive && <TopnavDarkSwitch />}

          <div className="header-icons d-inline-block align-middle">

            {topNavOptions.easyAccess && <TopnavEasyAccess />}

            {topNavOptions.notifications && <TopnavNotifications />}

            <button
              className="header-icon btn btn-empty d-none d-sm-inline-block"
              type="button"
              id="fullScreenButton"
              onClick={this.toggleFullScreen}
            >
              {this.state.isInFullScreen ? (
                <i className="simple-icon-size-actual d-block" />
              ) : (
                  <i className="simple-icon-size-fullscreen d-block" />
                )}
            </button>
          </div>
          <div className="user d-inline-block">
            <UncontrolledDropdown className="dropdown-menu-right">
              <DropdownToggle className="p-0 d-inline-flex align-items-center" color="empty">
                <div className="name mr-1 text-right">
                  <span className="font-weight-bold">{userAdmin.name}</span><br/><span className="text-small text-muted">{userAdmin.tag}</span>
                </div>
                <div>
                  <img alt="Profile" src={userAdmin.pic} onError={(e) => { e.target.onerror = null; e.target.src = require("../../assets/img/user.png") }} />
                </div>
              </DropdownToggle>
              <DropdownMenu className="mt-3" right>
                {/* <DropdownItem>My account</DropdownItem> 
                <DropdownItem onClick={() => this.toggleModal()}>Support</DropdownItem>
                <DropdownItem divider />
                */}
                <DropdownItem header className="item-name">
                  <div style={{fontSize: ".8rem"}}>
                    <span className="text-small font-weight-bold">{userAdmin.name}</span><br/>
                    <span className="text-small text-muted">{userAdmin.tag}</span>
                  </div>
                </DropdownItem>
                <DropdownItem onClick={() => this.handleLogout()}>
                  <IntlMessages id="main.logout" />
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
        <div className="beta">
          <div className="tri"></div>
          <div className="txt">BETA</div>
        </div>
      </nav>

    );
  }
}

const mapStateToProps = ({ menu, settings, authUser }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  const { locale, tenants, currentTenant } = settings;
  const { userAdmin } = authUser;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    locale,
    tenants,
    currentTenant,
    userAdmin
  };
};
export default injectIntl(
  connect(
    mapStateToProps,
    { setContainerClassnames, clickOnMobileMenu, logoutUser, loginUser, changeLocale, setCurrentTenant, setMenuItems, setLoader }
  )(TopNav)
);
